// src/components/SEO.js
import React from "react";
import { Helmet } from "react-helmet-async";
import seoConfig from "./seoConfig";

export default function SEO({
    title,
    description,
    keywords = "",
    image,
    type = "website",
    url = typeof window !== "undefined" ? window.location.href : seoConfig.siteUrl,
    schema = null,
}) {
    const metaTitle = title || seoConfig.defaultTitle;
    const metaDescription = description || seoConfig.defaultDescription;
    const metaImage = image || `${seoConfig.siteUrl}${seoConfig.defaultImage}`;

    return (
        <Helmet>
            {/* Basic SEO */}
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
            {keywords && <meta name="keywords" content={keywords} />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={metaImage} />
            <meta property="og:url" content={url} />
            <meta property="og:site_name" content="Mỹ Diệp Property" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={metaImage} />

            {/* Canonical link */}
            <link rel="canonical" href={url} />

            {/* Structured Data (Schema.org) */}
            {schema && (
                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            )}
        </Helmet>
    );
}
